import React from 'react';
import './AddContentSkeleton.scss';

const AddContentSkeleton = ({ is2w = false }) => {
    return (
        <div className="add-content-skeleton">
            <div className="skeleton-form-container">

                {/* Select Category / Select Vehicle Category */}
                <div className="skeleton-form-row">
                    <div className="skeleton-label" />
                    <div className="skeleton-input" />
                </div>

                {/* Select Vehicle */}
                <div className="skeleton-form-row">
                    <div className="skeleton-label" />
                    <div className="skeleton-multiselect" />
                </div>

                {/* Select Type of Content */}
                <div className="skeleton-form-row">
                    <div className="skeleton-label" />
                    <div className="skeleton-input" />
                </div>

                {/* Content Title */}
                <div className="skeleton-form-row">
                    <div className="skeleton-label" />
                    <div className="skeleton-textarea" />
                </div>

                {/* Description */}
                <div className="skeleton-form-row">
                    <div className="skeleton-label" />
                    <div className="skeleton-textarea" />
                </div>

                {/* Select File Type */}
                <div className="skeleton-form-row">
                    <div className="skeleton-label" />
                    <div className="skeleton-input" />
                </div>

                {/* File Upload */}
                <div className="skeleton-form-row">
                    <div className="skeleton-label" />
                    <div className="skeleton-file" />
                </div>

                {/* User Type - 2W only */}
                {is2w && (
                    <div className="skeleton-form-row">
                        <div className="skeleton-label" />
                        <div className="skeleton-multiselect" />
                    </div>
                )}

                {/* Action Buttons */}
                <div className="skeleton-actions">
                    <div className="skeleton-button" />
                    <div className="skeleton-button" />
                </div>
            </div>
        </div>
    );
};

export default AddContentSkeleton;
